import { createContext, useContext } from 'react';
import useCompanyReviews from './useCompanyReviews';
import { CompanyReviewsProviderResults, CompanyReviewsResponse } from './types';

type Ctx = CompanyReviewsProviderResults;

const CompanyReviewsContext = createContext<Ctx | null>(null);

export function useCompanyReviewsContext() {
  const ctx = useContext(CompanyReviewsContext);

  if (!ctx) {
    throw new Error(
      'useCompanyReviewsContext must be used within CompanyReviewsProvider',
    );
  }

  return ctx;
}

export function CompanyReviewsProvider({
  children,
  initialData,
}: {
  children: React.ReactNode;
  initialData?: CompanyReviewsResponse | null;
}) {
  const value = useCompanyReviews(initialData);

  return (
    <CompanyReviewsContext.Provider value={value}>
      {children}
    </CompanyReviewsContext.Provider>
  );
}
